@let features = featureConfiguration();

<div class="side-nav-container">
  <!-- Expanded navigation groups can change the sidebar's intrinsic width. -->
  <mat-sidenav-container autosize>
    <mat-sidenav
      id="helper-navigation"
      class="sidebar-container"
      [mode]="compactViewport() ? 'over' : 'side'"
      [opened]="showSideNav && (!compactViewport() || compactNavigationOpen())"
      [autoFocus]="compactViewport()"
      [attr.role]="compactViewport() ? 'dialog' : 'navigation'"
      [attr.aria-modal]="
        compactViewport() && compactNavigationOpen() ? true : null
      "
      aria-label="Hauptnavigation"
      i18n-aria-label="@@helperNavigationLabel"
      (closedStart)="compactNavigationOpen.set(false)"
      (closed)="onCompactNavigationClosed()"
      (click)="onNavigationClick($event)"
    >
      @if (compactViewport()) {
        <div class="compact-navigation-header">
          <span i18n="@@helperNavigationTitle">Navigation</span>
          <button
            mat-icon-button
            type="button"
            aria-label="Navigation schließen"
            i18n-aria-label="@@helperNavigationClose"
            (click)="compactNavigationOpen.set(false)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
      <div class="sidebar-stretch">
        <mat-nav-list
          aria-label="Arbeitsbereiche"
          i18n-aria-label="@@helperNavigationWorkspaces"
        >
          <button
            mat-list-item
            type="button"
            class="side-nav-group-header"
            routerLinkActive="is-nav-item-active"
            [routerLinkActiveOptions]="{ exact: true }"
            ariaCurrentWhenActive="page"
            [attr.aria-expanded]="expandedSection() === 'calls'"
            aria-controls="side-nav-calls-items"
            libTrackedAction="navigation.side_nav_start_call_clicked"
            routerLink="/video-appointments"
            queryParamsHandling="preserve"
            (click)="expandedSection.set('calls')"
          >
            <mat-icon matListItemIcon>videocam</mat-icon>
            <span matListItemTitle i18n="@@sideNavCalls">Anrufe</span>
          </button>
          <div
            id="side-nav-calls-items"
            [hidden]="expandedSection() !== 'calls'"
          >
            <a
              mat-list-item
              class="side-nav-child-item"
              routerLinkActive="is-nav-item-active"
              ariaCurrentWhenActive="page"
              libTrackedAction="navigation.side_nav_call_history_clicked"
              routerLink="/video-appointments/history"
              queryParamsHandling="preserve"
            >
              <mat-icon matListItemIcon>history</mat-icon>
              <span matListItemTitle i18n="@@sideNavHistory">Verlauf</span>
            </a>
            @if (roleService.isInRole(BackendRole.Manager) | async) {
              @if (features?.managersCanViewStatistics) {
                <a
                  mat-list-item
                  class="side-nav-child-item"
                  routerLinkActive="is-nav-item-active"
                  ariaCurrentWhenActive="page"
                  libTrackedAction="navigation.side_nav_statistics_clicked"
                  routerLink="/video-appointments/statistics"
                  queryParamsHandling="preserve"
                >
                  <mat-icon matListItemIcon>bar_chart</mat-icon>
                  <span matListItemTitle i18n>Statistiken</span>
                </a>
              }
            }
            @if (roleService.isInAnyRole(BackendRole.Admin) | async) {
              <a
                mat-list-item
                class="side-nav-child-item"
                routerLinkActive="is-nav-item-active"
                ariaCurrentWhenActive="page"
                libTrackedAction="navigation.side_nav_call_settings_clicked"
                routerLink="/video-appointments/settings"
                queryParamsHandling="preserve"
              >
                <mat-icon matListItemIcon>settings</mat-icon>
                <span matListItemTitle i18n>Einstellungen</span>
              </a>
            }
          </div>

          @if (features?.workflowConfiguration?.workflowsEnabled) {
            <button
              mat-list-item
              type="button"
              class="side-nav-group-header"
              routerLinkActive="is-nav-item-active"
              [routerLinkActiveOptions]="{ exact: true }"
              ariaCurrentWhenActive="page"
              [attr.aria-expanded]="expandedSection() === 'workflows'"
              aria-controls="side-nav-workflows-items"
              libTrackedAction="navigation.side_nav_start_workflow_clicked"
              routerLink="/workflows"
              queryParamsHandling="preserve"
              (click)="expandedSection.set('workflows')"
            >
              <mat-icon matListItemIcon>account_tree</mat-icon>
              <span matListItemTitle i18n="@@sideNavWorkflows">Workflows</span>
            </button>
            <div
              id="side-nav-workflows-items"
              [hidden]="expandedSection() !== 'workflows'"
            >
              @if (
                roleService.isInAnyRole(
                  BackendRole.Admin,
                  BackendRole.PlatformAdministrator
                ) | async
              ) {
                <a
                  mat-list-item
                  class="side-nav-child-item"
                  routerLinkActive="is-nav-item-active"
                  ariaCurrentWhenActive="page"
                  libTrackedAction="navigation.side_nav_workflow_configuration_clicked"
                  routerLink="/workflows/builder"
                  queryParamsHandling="preserve"
                >
                  <mat-icon matListItemIcon>tune</mat-icon>
                  <span matListItemTitle i18n="@@sideNavWorkflowBuilder"
                    >Builder</span
                  >
                </a>
              }
              <a
                mat-list-item
                class="side-nav-child-item"
                routerLinkActive="is-nav-item-active"
                ariaCurrentWhenActive="page"
                libTrackedAction="navigation.side_nav_workflow_history_clicked"
                routerLink="/workflows/history"
                queryParamsHandling="preserve"
              >
                <mat-icon matListItemIcon>history</mat-icon>
                <span matListItemTitle i18n="@@sideNavHistory">Verlauf</span>
              </a>
              @if (
                workflowOverviewEnabled(
                  features?.workflowConfiguration.statisticsConfiguration
                )
              ) {
                <a
                  mat-list-item
                  class="side-nav-child-item"
                  routerLinkActive="is-nav-item-active"
                  ariaCurrentWhenActive="page"
                  routerLink="/workflows/statistics"
                  queryParamsHandling="preserve"
                  libTrackedAction="navigation.side_nav_workflow_statistics_clicked"
                >
                  <mat-icon matListItemIcon>bar_chart</mat-icon
                  ><span matListItemTitle i18n="@@sideNavWorkflowOverview"
                    >Übersicht</span
                  >
                </a>
              }
              @if (
                workflowAnswersEnabled(
                  features?.workflowConfiguration.statisticsConfiguration
                )
              ) {
                <a
                  mat-list-item
                  class="side-nav-child-item"
                  routerLinkActive="is-nav-item-active"
                  ariaCurrentWhenActive="page"
                  routerLink="/workflows/answers"
                  queryParamsHandling="preserve"
                  libTrackedAction="navigation.side_nav_workflow_answers_clicked"
                >
                  <mat-icon matListItemIcon>poll</mat-icon
                  ><span matListItemTitle i18n="@@sideNavWorkflowAnswers"
                    >Antworten</span
                  >
                </a>
              }
            </div>
          }
          @if (features?.casesEnabled) {
            <a
              mat-list-item
              routerLinkActive="is-nav-item-active"
              ariaCurrentWhenActive="page"
              libTrackedAction="navigation.side_nav_cases_clicked"
              routerLink="/cases"
              queryParamsHandling="preserve"
            >
              <mat-icon matListItemIcon>folder_open</mat-icon>
              <span matListItemTitle i18n="@@casesHeading">Fälle</span>
            </a>
          }
          @if (features?.tasksEnabled !== false) {
            <a
              mat-list-item
              routerLinkActive="is-nav-item-active"
              ariaCurrentWhenActive="page"
              libTrackedAction="navigation.side_nav_tasks_clicked"
              routerLink="/tasks"
              queryParamsHandling="preserve"
            >
              <mat-icon matListItemIcon>task_alt</mat-icon>
              <span matListItemTitle i18n="@@sideNavTasks">Aufgaben</span>
            </a>
          }
          <div class="workflow-nav-spacer" aria-hidden="true"></div>
          <mat-divider></mat-divider>

          <button
            mat-list-item
            type="button"
            class="side-nav-group-header"
            [attr.aria-expanded]="expandedSection() === 'customers'"
            aria-controls="side-nav-customers-items"
            libTrackedAction="navigation.side_nav_customers_clicked"
            routerLink="/customer/person"
            queryParamsHandling="preserve"
            (click)="expandedSection.set('customers')"
          >
            <mat-icon matListItemIcon>people</mat-icon>
            <span matListItemTitle i18n>Kunden</span>
          </button>
          <div
            id="side-nav-customers-items"
            [hidden]="expandedSection() !== 'customers'"
          >
            <a
              mat-list-item
              class="side-nav-child-item"
              routerLinkActive="is-nav-item-active"
              ariaCurrentWhenActive="page"
              libTrackedAction="navigation.side_nav_customer_contacts_clicked"
              routerLink="/customer/person"
              queryParamsHandling="preserve"
            >
              <mat-icon matListItemIcon>person</mat-icon>
              <span matListItemTitle i18n>Kontakte</span>
            </a>
            <a
              mat-list-item
              class="side-nav-child-item"
              routerLinkActive="is-nav-item-active"
              ariaCurrentWhenActive="page"
              libTrackedAction="navigation.side_nav_customer_companies_clicked"
              routerLink="/customer/company"
              queryParamsHandling="preserve"
            >
              <mat-icon matListItemIcon>corporate_fare</mat-icon>
              <span matListItemTitle i18n>Unternehmen</span>
            </a>
          </div>

          @if (roleService.isInRole(BackendRole.Manager) | async) {
            <a
              mat-list-item
              routerLinkActive="is-nav-item-active"
              ariaCurrentWhenActive="page"
              libTrackedAction="navigation.side_nav_attachments_clicked"
              routerLink="/attachment"
              queryParamsHandling="preserve"
            >
              <mat-icon matListItemIcon>attachment</mat-icon>
              <span matListItemTitle i18n>Anhänge</span>
            </a>
            <a
              mat-list-item
              routerLinkActive="is-nav-item-active"
              ariaCurrentWhenActive="page"
              libTrackedAction="navigation.side_nav_employee_clicked"
              routerLink="/employee"
              queryParamsHandling="preserve"
            >
              <mat-icon matListItemIcon>support_agent</mat-icon>
              <span matListItemTitle i18n>Mitarbeiter</span>
            </a>
          }
        </mat-nav-list>
      </div>
      <div class="bottom-section">
        <mat-nav-list
          aria-label="Persönliche Einstellungen"
          i18n-aria-label="@@helperNavigationPersonalSettings"
        >
          <mat-divider></mat-divider>
          <a
            mat-list-item
            routerLinkActive="is-nav-item-active"
            ariaCurrentWhenActive="page"
            libTrackedAction="navigation.side_nav_video_audio_settings_clicked"
            routerLink="/device-setup"
            queryParamsHandling="preserve"
          >
            <mat-icon matListItemIcon>video_settings</mat-icon>
            <span matListItemTitle i18n>Video & Audio</span>
          </a>
          <a
            mat-list-item
            routerLinkActive="is-nav-item-active"
            ariaCurrentWhenActive="page"
            libTrackedAction="navigation.side_nav_profile_clicked"
            routerLink="/profile"
            queryParamsHandling="preserve"
          >
            <mat-icon matListItemIcon>account_circle</mat-icon>
            <span matListItemTitle i18n>Profil</span>
          </a>

          <button
            mat-list-item
            type="button"
            class="side-nav-group-header"
            [attr.aria-expanded]="expandedSection() === 'settings'"
            aria-controls="side-nav-settings-items"
            libTrackedAction="navigation.side_nav_company_clicked"
            routerLink="/settings/general"
            queryParamsHandling="preserve"
            (click)="expandedSection.set('settings')"
          >
            <mat-icon matListItemIcon>settings</mat-icon>
            <span matListItemTitle i18n>Einstellungen</span>
          </button>
          <div
            id="side-nav-settings-items"
            [hidden]="expandedSection() !== 'settings'"
          >
            <a
              mat-list-item
              class="side-nav-child-item"
              routerLinkActive="is-nav-item-active"
              ariaCurrentWhenActive="page"
              libTrackedAction="navigation.side_nav_company_general_clicked"
              routerLink="/settings/general"
              queryParamsHandling="preserve"
            >
              <mat-icon matListItemIcon>business</mat-icon>
              <span matListItemTitle i18n>Firma</span>
            </a>
            @if (roleService.isInRole(BackendRole.Admin) | async) {
              <a
                mat-list-item
                class="side-nav-child-item"
                routerLinkActive="is-nav-item-active"
                ariaCurrentWhenActive="page"
                libTrackedAction="navigation.side_nav_company_branding_clicked"
                routerLink="/settings/branding"
                queryParamsHandling="preserve"
              >
                <mat-icon matListItemIcon>brush</mat-icon>
                <span matListItemTitle i18n>Branding</span>
              </a>

              <a
                mat-list-item
                class="side-nav-child-item"
                routerLinkActive="is-nav-item-active"
                ariaCurrentWhenActive="page"
                libTrackedAction="navigation.side_nav_company_security_clicked"
                routerLink="/settings/security"
                queryParamsHandling="preserve"
              >
                <mat-icon matListItemIcon>security</mat-icon>
                <span matListItemTitle i18n>Sicherheit</span>
              </a>
            }
            @if (debugEnabled) {
              <a
                mat-list-item
                class="side-nav-child-item"
                routerLinkActive="is-nav-item-active"
                ariaCurrentWhenActive="page"
                libTrackedAction="navigation.side_nav_debug_clicked"
                routerLink="/debug"
                queryParamsHandling="preserve"
              >
                <mat-icon matListItemIcon>bug_report</mat-icon>
                <span matListItemTitle>Debug</span>
              </a>
            }
          </div>
        </mat-nav-list>
        <app-version-info></app-version-info>
        <app-install-pwa></app-install-pwa>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="content">
        <router-outlet
          (activate)="onRouterOutletActivate($event)"
        ></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
